module.exports = __webpack_public_path__ + "static/img/alexander_pictgrid8_800x739.602981d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/alexander_pictgrid8_800x739.jpg
// module id = hJOJ
// module chunks = 0